import React, {useEffect, useState} from "react";
import SelectedDatasetElement from "../SelectedDatasetElement";
import {Axis, AxisAssignedArrays, Dataset, DatasetAxis} from "../models/types";
import "./styles.css";
import {SelectButton} from "primereact/selectbutton";

const MultiDragArea = ({
                           selectedDatasetsArr,
                           removeDataset,
                           enableXAxis,
                           assignToMultiAxis,
                           colorScale,
                           setColorScale
                       }: {
    selectedDatasetsArr: Array<Dataset>;
    removeDataset: any;
    enableXAxis: boolean;
    assignToMultiAxis: any;

    colorScale: boolean;
    setColorScale: (val: boolean) => void;
}) => {
    const [datasetsWithMultiAxis, setDatasetsWithMultiAxis] = useState<Array<DatasetAxis>>([]);
    const [multiAxisArray, setMultiAxisArray] = useState<AxisAssignedArrays>({
        none: [],
        X: [],
        Y: [],
        size: [],
        color: []
    });
    const [fieldXClassName, setFieldXClassName] = useState<string>("empty");
    const [fieldYClassName, setFieldYClassName] = useState<string>("empty");

    const options = [
        {name: 'Range', value: true},
        {name: 'Discrete', value: false}
    ]

    const onDragStart = (e: any, id: string) => {
        e.dataTransfer.setData("id", id);
    };

    const onDragOver = (e: any) => {
        e.preventDefault();
    };

    const onDropWithSwitch = (e: any, targetAxis: Axis) => {
        const id = e.dataTransfer.getData("id");

        let dts = datasetsWithMultiAxis.map(dt => {
            if (dt.identifier === id && targetAxis == "none") {
                dt.axis = targetAxis;
            } else {
                //switch current with target
                if (dt.identifier === id) {
                    const currentAxis = dt.axis;

                    const dtTargetAxisIndex = datasetsWithMultiAxis.findIndex((dta) => dta.axis === targetAxis);
                    dt.axis = targetAxis;

                    if (dtTargetAxisIndex !== -1) {
                        datasetsWithMultiAxis[dtTargetAxisIndex].axis = currentAxis;
                    }
                }
            }
            return dt;
        });
        setDatasetsWithMultiAxis(dts);
    };

    useEffect(() => {
        if (selectedDatasetsArr.length === 0) {
            setDatasetsWithMultiAxis(selectedDatasetsArr.reduce((res: Array<DatasetAxis>, curr, index) => {
                switch (index) {
                    case 0:
                        res.push({...curr, axis: "X"});
                        break;
                    case 1:
                        res.push({...curr, axis: "Y"});
                        break;
                    case 2:
                        res.push({...curr, axis: "color"});
                        break;
                    case 3:
                        res.push({...curr, axis: "size"});
                        break;
                    default:
                        res.push({...curr, axis: "none"});
                }
                return res;
            }, []))
        } else {

        }
        setDatasetsWithMultiAxis(selectedDatasetsArr.reduce((res: Array<DatasetAxis>, curr, index) => {
            switch (index) {
                case 0:
                    res.push({...curr, axis: "X"});
                    break;
                case 1:
                    res.push({...curr, axis: "Y"});
                    break;
                case 2:
                    res.push({...curr, axis: "color"});
                    break;
                case 3:
                    res.push({...curr, axis: "size"});
                    break;
                default:
                    res.push({...curr, axis: "none"});
            }
            return res;
        }, []))
    }, [selectedDatasetsArr]);

    useEffect(() => {
        setMultiAxisArray({none: [], X: [], Y: [], size: [], color: []});
        const tempArr: AxisAssignedArrays = {none: [], X: [], Y: [], size: [], color: []};
        datasetsWithMultiAxis.forEach((d) => {
            tempArr[d.axis]?.push(
                <SelectedDatasetElement key={d.identifier}
                                        selectedDataset={d}
                                        removeDataset={removeDataset}
                                        dragStart={onDragStart}/>
            );
        });

        if (tempArr["X"] != null && tempArr["Y"] != null) {
            const xDataset: string = tempArr["X"][0]?.props.selectedDataset.identifier;
            const yDataset: string = tempArr["Y"][0]?.props.selectedDataset.identifier;
            let colorDataset: string = "";
            let sizeDataset: string = "";

            if (tempArr["color"] && tempArr.color?.length > 0) {
                colorDataset = tempArr["color"][0].props.selectedDataset.identifier;
            }
            if (tempArr["size"] && tempArr.size?.length > 0) {
                sizeDataset = tempArr["size"][0].props.selectedDataset.identifier;
            }
            assignToMultiAxis(xDataset, yDataset, colorDataset, sizeDataset, colorScale);
            if(colorDataset==="") {
                setColorScale(true)
            }
            setMultiAxisArray(tempArr);
        }
    }, [datasetsWithMultiAxis]);

    useEffect(() => {
        const foundXIndex = datasetsWithMultiAxis.findIndex((d) => d.axis === "X");
        const foundYIndex = datasetsWithMultiAxis.findIndex((d) => d.axis === "Y");
        setFieldXClassName(foundXIndex !== -1 ? "" : "empty");
        setFieldYClassName(foundYIndex !== -1 ? "" : "empty");
    }, [datasetsWithMultiAxis]);

    return <div className="padding flex gap-3">
        <div>
            <label htmlFor="multi-select">Selected multi datasets: </label>
            <div className="drop-box"
                 id="multi-select"
                 onDragOver={(e) => onDragOver(e)}
                 onDrop={(e) => {
                     onDropWithSwitch(e, "none");
                 }}
            >
                {multiAxisArray.none}
            </div>
        </div>
        <div className="flexColumn">
            {enableXAxis && (
                <div className="" id="dropbox">
                    <label htmlFor="dropboxX">X axis: </label>
                    <div
                        className={`drop-box ${fieldXClassName}`}
                        id="dropboxX"
                        onDragOver={(e) => onDragOver(e)}
                        onDrop={(e) => {
                            onDropWithSwitch(e, "X");
                        }}
                    >
                        {multiAxisArray.X}
                    </div>

                </div>
            )}
            <div className="" id="dropbox">
                <label htmlFor="dropboxY">Y axis: </label>
                <div className={`drop-box ${fieldYClassName}`}
                     id="dropboxY"
                     onDragOver={(e) => onDragOver(e)}
                     onDrop={(e) => {
                         onDropWithSwitch(e, "Y");
                     }}
                >
                    {multiAxisArray.Y}
                </div>
            </div>
        </div>
        <div className="flexColumn">
            <div className={"flex align-items-center"}>
                <div id="dropbox">
                    <label htmlFor="dropboxColor">Color axis: </label>

                    <div
                        className={`drop-box`}
                        id="dropboxColor"
                        onDragOver={(e) => onDragOver(e)}
                        onDrop={(e) => {
                            onDropWithSwitch(e, "color");
                        }}
                    >
                        {multiAxisArray.color}
                    </div>
                </div>
                <div className={"pt-4"}>
                    <SelectButton value={colorScale}
                                  options={options}
                                  onChange={(e) => setColorScale(e.value)}
                                  optionLabel="name"
                                  style={{whiteSpace: "nowrap", transform: "scale(90%)"}}
                                  disabled={multiAxisArray.color?.length === 0}
                    />
                </div>

            </div>

            <div className="" id="dropbox">
                <label htmlFor="dropboxSize">Size axis: </label>
                <div className={`drop-box`}
                     id="dropboxsize"
                     onDragOver={(e) => onDragOver(e)}
                     onDrop={(e) => {
                         onDropWithSwitch(e, "size");
                     }}
                >
                    {multiAxisArray.size}
                </div>
            </div>
        </div>
    </div>
};

export default MultiDragArea;